import React from 'react';
import { color as palette, scale } from "@/constants/palette";

function Fail() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='46'
      height='46'
      viewBox='0 0 46 46'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23 45.7812C10.4183 45.7812 0.21875 35.5817 0.21875 23C0.21875 10.4183 10.4183 0.21875 23 0.21875C35.5817 0.21875 45.7812 10.4183 45.7812 23C45.7812 35.5817 35.5817 45.7812 23 45.7812Z'
        fill={scale.red[100]}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.0976 13.4981C20.0443 12.1345 21.1354 11 22.5 11C23.8646 11 24.9557 12.1345 24.9024 13.4981L24.4482 25.1264C24.4073 26.1728 23.5472 27 22.5 27C21.4528 27 20.5927 26.1728 20.5518 25.1264L20.0976 13.4981Z'
        fill={palette.error}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.4905 35C21.1027 35 20 33.9147 20 32.5C20 31.0853 21.1027 30 22.4905 30C23.9163 30 25 31.0853 25 32.5C25 33.9147 23.9163 35 22.4905 35Z'
        fill={palette.error}
      />
    </svg>
  );
}

export default Fail;
